module.exports = __webpack_public_path__ + "static/media/category-2.bc717786.png";